import { broadcastOnce } from '@enterprise/core';

export const NTH_CALCULATOR_CHANNEL = 'datastream:nth-calculator';

export const broadcastNthCalculatorReturnToPanel = (): void => {
  broadcastOnce(NTH_CALCULATOR_CHANNEL, { type: 'return-to-panel' });
};

export const broadcastNthCalculatorDraftUpdated = (mailingId: number): void => {
  broadcastOnce(NTH_CALCULATOR_CHANNEL, { type: 'draft-updated', mailingId });
};
